export default function Popup(props) {
  return (
    <section className="side-popup">
      <ul>
        {props.products.map((item, index) => (
          <li className="stores popup" key={index}>
            <a href={item.Link} target="blank">
              <span className="icon-wrapper">
                <img
                  className="icon"
                  src={`https://spagnoladmin.spagnolcompany.it${item.Icon.data.attributes.url}`}
                />
              </span>
              <span className="side-label">{item.Label}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
